import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = { style: {"float":"left","padding-left":"5px","padding-bottom":"5px","padding-top":"3px"} }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1)

import { reactive, onMounted, computed,watch } from 'vue';
import { ButtonInfo, SearchInput } from '../Entity/pageButtonInfo';
import { ElMessage } from 'element-plus';
import $http from '../http/index';
import $helper from '@/helper/helper';

// 入参

export default /*#__PURE__*/_defineComponent({
  __name: 'SizeSearchCondition',
  props: {
    sizeSearchClassify: null
  },
  emits: ['showSizeSearchData','searching','searched'],
  setup(__props: any, { emit }) {

const props = __props as {
    sizeSearchClassify:string
};





onMounted(()=>{
    data.sizeSearchClassify = props.sizeSearchClassify;
    let sizeSearchInputsStr = window.sessionStorage.getItem("sizeSearchInputs");
    if(sizeSearchInputsStr){
        data.sizeSearchInputs = JSON.parse(sizeSearchInputsStr)
    }
    const brandDecoration = $helper.getBrandDecoration();
    if(brandDecoration.BrandInputColor){
        data.checkProductTypeCheckStyle=`background-color:#${brandDecoration.BrandInputColor}`
    }
})

class InitData {
    /**
     * 尺寸查询条件类别
     */
    sizeSearchClassify = 'BrakePads'

    /**
     * 尺寸查询条件全部类别
     */
    sizeSearchClassifies: Array<ButtonInfo> = [
        { type: '', text: '刹车片', code: "BrakePads", icon: '',isShow:true },
        { type: '', text: '刹车蹄', code: "BrakeShoe", icon: '' ,isShow:true},
        { type: '', text: '报警线', code: "WarnLine", icon: '' ,isShow:true},
        { type: '', text: '刹车盘', code: "BrakeDisc", icon: '' ,isShow:true},
        { type: '', text: '刹车鼓', code: "BrakeDrum", icon: '' ,isShow:true}
    ]

    /**
   * 尺寸查询条件输入项
   */
    sizeSearchInputs:Array<SearchInput>=[
        { type: '', text: '长', code: "Length", icon: '',inputValue:'',classify:'BrakePads' },
        { type: '', text: '宽', code: "Width", icon: '',inputValue:'',classify:'BrakePads' },
        { type: '', text: '摩擦块宽', code: "FrictionBlock", icon: '',inputValue:'',classify:'BrakePads' },
        { type: '', text: '厚', code: "Thickness", icon: '',inputValue:'',classify:'BrakePads' },
        { type: '', text: '偏差', code: "Offset", icon: '',inputValue:'',classify:'BrakePads' },
        { type: '', text: '外径', code: "Diameter", icon: '',inputValue:'',classify:'BrakeShoe' },
        { type: '', text: '宽', code: "Width", icon: '',inputValue:'',classify:'BrakeShoe' },
        { type: '', text: '偏差', code: "Offset", icon: '',inputValue:'',classify:'BrakeShoe' },
        { type: '', text: '长度1', code: "Length_1", icon: '',inputValue:'',classify:'WarnLine' },
        { type: '', text: '长度2', code: "Length_2", icon: '',inputValue:'',classify:'WarnLine' },
        { type: '', text: '偏差', code: "Offset", icon: '',inputValue:'',classify:'WarnLine' },
        { type: '', text: '直径', code: "Diameter", icon: '',inputValue:'',classify:'BrakeDisc' },
        { type: '', text: '盘厚', code: "Thickness", icon: '',inputValue:'',classify:'BrakeDisc' },
        { type: '', text: '高度', code: "Height", icon: '',inputValue:'',classify:'BrakeDisc' },
        { type: '', text: '中间孔直径', code: "HoleCircle", icon: '',inputValue:'',classify:'BrakeDisc' },
        { type: '', text: '孔数', code: "HolesNum", icon: '',inputValue:'',classify:'BrakeDisc' },
        { type: '', text: '节圆直径', code: "PitchCircle", icon: '',inputValue:'',classify:'BrakeDisc' },
        { type: '', text: '偏差', code: "Offset", icon: '',inputValue:'',classify:'BrakeDisc' },
        { type: '', text: '外直径', code: "Diameter", icon: '',inputValue:'',classify:'BrakeDrum' },
        { type: '', text: '内直径', code: "InnerDiamete", icon: '',inputValue:'',classify:'BrakeDrum' },
        { type: '', text: '总高', code: "Height", icon: '',inputValue:'',classify:'BrakeDrum' },
        { type: '', text: '内高', code: "InnerHeight", icon: '',inputValue:'',classify:'BrakeDrum' },
        { type: '', text: '中间孔直径', code: "HoleCircle", icon: '',inputValue:'',classify:'BrakeDrum' },
        { type: '', text: '孔数', code: "HolesNum", icon: '',inputValue:'',classify:'BrakeDrum' },
        { type: '', text: '节圆直径', code: "PitchCircle", icon: '',inputValue:'',classify:'BrakeDrum' },
        { type: '', text: '偏差', code: "Offset", icon: '',inputValue:'',classify:'BrakeDrum' }
    ]
    checkProductTypeCheckStyle="background-color:#F00"
}

const data = reactive(new InitData());

/**
 * 当前查询输入项
 */
const currentSearchInputs = computed(()=>{
    return data.sizeSearchInputs.filter(c=>c.classify ==data.sizeSearchClassify)
})

const checkSearchClassifyEvent = (code:string)=>{
    data.sizeSearchClassify = code;
}

/**
 * 通过监听sizeSearchClassify值，计算显示当前的分类。
 */
watch(()=>props.sizeSearchClassify,()=>{
    data.sizeSearchClassify = props.sizeSearchClassify;
})

/**
 * 查询操作
 */
const search = () =>{
    let isInputSearchConditon = false; //是否输入查询条件
    let serchParam:Array<SearchInput> = [];
    for(let index =0 ; index < data.sizeSearchInputs.length ; index++){
        if(data.sizeSearchInputs[index].classify ==data.sizeSearchClassify){
            serchParam.push(data.sizeSearchInputs[index]);
            if(data.sizeSearchInputs[index].inputValue &&data.sizeSearchInputs[index].code!="Offset"){
                isInputSearchConditon=true;
            }
        }
    }
    if(isInputSearchConditon==false){
        ElMessage({
            message: '先输入尺寸信息',
            type: 'warning',
        })
        return;
    }
    emit("searching")
    $http({
        url: "/API/Product/ProductBySizeSearch",
        method: "POST",
        data: {
            searchInput: JSON.stringify(serchParam),
        }
    }).then(res => {
        if(res.data.length<1){
            ElMessage({
                message: $helper.lan('暂无数据提供'),
                type: 'warning',
            })
        }
        for(let i=0;i<res.data.length;i++){
            res.data[i].MapCode = ''
        }
        emit("showSizeSearchData",JSON.stringify(res.data),data.sizeSearchClassify)
        emit("searched")
    }).finally(()=>{
        emit("searched")
    })
    window.sessionStorage.setItem("sizeSearchInputs",JSON.stringify(data.sizeSearchInputs));
}

/**
 * 重置查询条件
 */
const resetSearchCondition = ()=>{
    for(let index =0 ; index < data.sizeSearchInputs.length ; index++){
        if(data.sizeSearchInputs[index].classify ==data.sizeSearchClassify){
            data.sizeSearchInputs[index].inputValue = '';
        }
    }
    window.sessionStorage.setItem("sizeSearchInputs",JSON.stringify(data.sizeSearchInputs));
}

/**
 * 查询输入框样式
 * @param classify 
 */
const inputStyle=(classify:string)=>{
    if(classify=="BrakePads" ||classify=="BrakeShoe"||classify=="WarnLine"){
        return {
            'width': '100px',
            'margin-right': '5px'
        }
    }
    if(classify=="BrakeDisc" ){
        return {
            'width': '85px',
            'margin-right': '5px'
        }
    }
    return {
        'width': '70px',
        'margin-right': '5px'
    }
}

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_link = _resolveComponent("el-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 8,
          style: {"padding-left":"5px","padding-bottom":"5px"}
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref($helper).lan('按尺寸查询，请输入关键信息(mm)')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 24-8-data.sizeSearchClassifies.length*2
        }, null, 8, ["span"]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.sizeSearchClassifies, (classify) => {
          return (_openBlock(), _createBlock(_component_el_col, {
            span: 2,
            key: classify.code
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                style: _normalizeStyle(data.sizeSearchClassify == classify.code ? data.checkProductTypeCheckStyle : ''),
                onClick: ($event: any) => (checkSearchClassifyEvent(classify.code))
              }, [
                _createElementVNode("div", {
                  class: "checkSearchClassify",
                  style: _normalizeStyle(data.sizeSearchClassify == classify.code ? 'color:#CCC' : '')
                }, _toDisplayString(_unref($helper).lan(classify.text)), 5)
              ], 12, _hoisted_1)
            ]),
            _: 2
          }, 1024))
        }), 128))
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, { style: {"margin-top":"5px"} }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 24 }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentSearchInputs), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                style: {"float":"left","padding-left":"5px","padding-bottom":"5px"},
                key: item.code
              }, [
                _createVNode(_component_el_text, {
                  class: "mx-1",
                  style: {"font-weight":"600"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($helper).lan(item.text)), 1)
                  ]),
                  _: 2
                }, 1024),
                _createTextVNode("  "),
                _createVNode(_component_el_input, {
                  type: "number",
                  style: _normalizeStyle(inputStyle(item.classify)),
                  modelValue: item.inputValue,
                  "onUpdate:modelValue": ($event: any) => ((item.inputValue) = $event),
                  placeholder: _unref($helper).lan('输入')
                }, null, 8, ["style", "modelValue", "onUpdate:modelValue", "placeholder"])
              ]))
            }), 128)),
            _createElementVNode("div", _hoisted_2, [
              _createTextVNode("   "),
              _createVNode(_component_el_link, {
                underline: false,
                onClick: search
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h3", null, _toDisplayString(_unref($helper).lan('查询')), 1)
                ]),
                _: 1
              }),
              _createTextVNode("   "),
              _createVNode(_component_el_link, {
                underline: false,
                onClick: resetSearchCondition
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h3", null, _toDisplayString(_unref($helper).lan('重置')), 1)
                ]),
                _: 1
              })
            ]),
            _hoisted_3
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})